import React from "react";
import { TableHeader } from "app/components/Table/types";
import { GroupByTypeEnum } from "../../../../types";

import RowFieldRenderer from "./RowFieldRenderer";
import { useTicketFieldUpdate } from "../useTicketFieldUpdate";
import { ITickets } from "../../types";

interface Props {
  header: TableHeader[];
  ticket: ITickets;
  isSelected: boolean;
  projectId: string;
}

const RowCustomize: React.FC<Props> = ({
  header,
  ticket,
  isSelected,
  projectId,
}) => {
  const { handleUpdate } = useTicketFieldUpdate(ticket._id, projectId);

  return (
    <>
      {header.map((h) => {
        return (
          <RowFieldRenderer
            key={h.id}
            field={h.id as GroupByTypeEnum}
            ticket={ticket}
            isSelected={isSelected}
            onUpdate={handleUpdate}
          />
        );
      })}
    </>
  );
};

export default RowCustomize;
